import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook personalizado para gestión de navegación
 * Extrae lógica de navegación reutilizable
 */
export const useNavigation = (routes) => {
  const location = useLocation();
  const [currentRoute, setCurrentRoute] = useState('Main Dashboard');

  useEffect(() => {
    const getActiveRoute = (routeList) => {
      let activeRoute = 'Default Brand Text';

      for (let i = 0; i < routeList.length; i++) {
        if (routeList[i].collapse) {
          const collapseActiveRoute = getActiveRoute(routeList[i].items);
          if (collapseActiveRoute !== activeRoute) return collapseActiveRoute;
        } else if (routeList[i].category) {
          const categoryActiveRoute = getActiveRoute(routeList[i].items);
          if (categoryActiveRoute !== activeRoute) return categoryActiveRoute;
        } else if (
          window.location.href.indexOf(
            routeList[i].layout + routeList[i].path
          ) !== -1
        ) {
          setCurrentRoute(routeList[i].name);
        }
      }
      return activeRoute;
    };

    getActiveRoute(routes);
  }, [location.pathname, routes]);

  // Función recursiva para obtener estado de navbar
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;

    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };

  // Función recursiva para obtener texto de navbar
  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;

    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };

  // Generar rutas filtradas por layout
  const getRoutes = (routes, layoutType) => {
    const layoutPath = `/${layoutType}`;
    const result = [];

    const processRoutes = (routeList, parentKey = '') => {
      routeList.forEach((prop, index) => {
        const uniqueKey = `${parentKey}-${index}`;

        if (prop.layout === layoutPath) {
          result.push({
            path: prop.path,
            element: prop.component,
            key: uniqueKey,
          });
        }

        if (prop.collapse && prop.items) {
          processRoutes(prop.items, `${uniqueKey}-collapse`);
        }

        if (prop.category && prop.items) {
          processRoutes(prop.items, `${uniqueKey}-category`);
        }
      });
    };

    processRoutes(routes);
    return result;
  };

  return {
    currentRoute,
    getActiveNavbar,
    getActiveNavbarText,
    getRoutes,
  };
};
